import PriceDisplay from '@/components/PriceDisplay';
import { addAncillaryLoadingSelector } from '@/features/loading/loadingSelectors';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { breakpoints } from '@/utils/breakpoints';
import { Button, Icons, Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';
import { useMediaQuery } from 'react-responsive';

interface AncillaryModalFooterProps {
  totalAmount: number;
  onOverlayOpened: (open: boolean) => void;
  onSubmit: () => void;
  isSubmitDisabled?: boolean;
}

const AncillaryModalFooter: FC<AncillaryModalFooterProps> = ({
  totalAmount,
  onOverlayOpened,
  onSubmit,
  isSubmitDisabled,
}) => {
  const isPending = useSelector(addAncillaryLoadingSelector);
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  return (
    <div className="flex w-full flex-col items-center gap-2 laptop:flex-row">
      <div className="flex w-full gap-2">
        <Icons.travelPass height={20} width={20} className="text-primary" />
        <Typography variant="body1" className="text-neutral">
          <TransText i18nKey="totalPrice" />:
        </Typography>
        <Typography variant="subtitle" className="text-primary">
          <PriceDisplay amount={totalAmount} />
        </Typography>
      </div>
      <div className="flex w-full gap-2 laptop:justify-end">
        <Button
          size={isLaptopOrBigger ? 'regular' : 'large'}
          variant="tertiary"
          data-testid="ancillary-selection-cancel-button"
          className="rounded-lg laptop:w-auto"
          onClick={() => onOverlayOpened(false)}
        >
          <TransText i18nKey="cancel" />
        </Button>
        <Button
          size={isLaptopOrBigger ? 'regular' : 'large'}
          data-testid="ancillary-selection-submit-button"
          className="rounded-lg laptop:w-auto"
          onClick={onSubmit}
          isPending={isPending}
          isDisabled={isSubmitDisabled}
          startAdornment={
            <Icons.check
              height={isLaptopOrBigger ? 16 : 24}
              width={isLaptopOrBigger ? 16 : 24}
            />
          }
        >
          <TransText i18nKey="confirm" />
        </Button>
      </div>
    </div>
  );
};

export default AncillaryModalFooter;
